<template>
  <div v-if="visible">
    <a-modal
      :visible="visible"
      @cancel="handleCancel"
      width="95%"
      :title="$t('all.enterInformationBelow') + ' ' + certif.name"
      :footer="false"
    >
      <a-form
        :form="formEdit"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 15 }"
      >
        <div class="row">
          <div class="col-8" style="height: 70vh" :loading="true">
            <!--<div
              v-if="loadingPdfPreview"
              style="
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a-spin size="large" />
            </div>-->
            <iframe
              :src="pdfBlobUrl"
              style="background-color: #eee; height: 100%; width: 100%"
            >
            </iframe>
          </div>
          <div class="col-4">
            <a-collapse default-active-key="1" accordion>
              <!-- General Settings Panel -->
              <a-collapse-panel
                key="1"
                :header="$t('certification.generalSettings')"
              >
                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item
                      :label="$t('certification.orientation')"
                      class="mb-0"
                    >
                      <a-select
                        :placeholder="
                          $t('certification.placeholderOrientation')
                        "
                        v-model="configPrint.orientation"
                        style="width: 100%"
                      >
                        <a-select-option value="p">{{
                          $t("certification.vertical")
                        }}</a-select-option>
                        <a-select-option value="l">{{
                          $t("certification.horizontal")
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-item
                      :label="$t('certification.positionX')"
                      class="mb-0"
                    >
                      <a-select
                        :placeholder="$t('certification.placeholderPositionX')"
                        v-model="configPrint.xAlign"
                        style="width: 100%"
                      >
                        <a-select-option value="center">{{
                          $t("certification.centered")
                        }}</a-select-option>
                        <a-select-option value="left">{{
                          $t("certification.atStart")
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-item :label="$t('certification.font')" class="mb-0">
                      <a-select
                        :placeholder="$t('certification.placeholderSelectFont')"
                        v-model="configPrint.font"
                        style="width: 100%"
                      >
                        <a-select-opt-group
                          v-for="(group, index) in fontGroups"
                          :key="index"
                          :label="group.label"
                        >
                          <a-select-option
                            v-for="font in group.options"
                            :key="font.value"
                            :value="font.value"
                          >
                            {{ font.label }}
                          </a-select-option>
                        </a-select-opt-group>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>

              <!-- Student Name Panel -->
              <a-collapse-panel
                key="2"
                :header="$t('certification.studentName')"
              >
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderX')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderX')"
                        class="w-100"
                        v-model="configPrint.fullName.x"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderY')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderY')"
                        class="w-100"
                        v-model="configPrint.fullName.y"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.size') + ' :'"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderTextSize')"
                        class="w-100"
                        v-model="configPrint.fullName.fontSize"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.color') + ' :'"
                      class="mb-0"
                    >
                      <input
                        type="color"
                        v-model="configPrint.fullName.color"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>

              <!-- Class Name Panel -->
              <a-collapse-panel key="3" :header="$t('certification.className')">
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderX')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderX')"
                        class="w-100"
                        v-model="configPrint.className.x"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderY')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderY')"
                        class="w-100"
                        v-model="configPrint.className.y"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.size') + ' :'"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderTextSize')"
                        class="w-100"
                        v-model="configPrint.className.fontSize"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.color') + ' :'"
                      class="mb-0"
                    >
                      <input
                        type="color"
                        v-model="configPrint.className.color"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>

              <!-- Trimester Panel -->
              <a-collapse-panel
                key="4"
                :header="$t('certification.trimesterName')"
              >
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderX')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderX')"
                        class="w-100"
                        v-model="configPrint.trimestre.x"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderY')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderY')"
                        class="w-100"
                        v-model="configPrint.trimestre.y"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.size') + ' :'"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderTextSize')"
                        class="w-100"
                        v-model="configPrint.trimestre.fontSize"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.color') + ' :'"
                      class="mb-0"
                    >
                      <input
                        type="color"
                        v-model="configPrint.trimestre.color"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>

              <!-- School Year Panel -->
              <a-collapse-panel
                key="5"
                :header="$t('certification.schoolYearHeader')"
              >
                <a-row :gutter="16">
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderX')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderX')"
                        class="w-100"
                        v-model="configPrint.schoolYear.x"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.placeholderY')"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderY')"
                        class="w-100"
                        v-model="configPrint.schoolYear.y"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.size') + ' :'"
                      class="mb-0"
                    >
                      <a-input-number
                        :placeholder="$t('certification.placeholderTextSize')"
                        class="w-100"
                        v-model="configPrint.schoolYear.fontSize"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item
                      :label="$t('certification.color') + ' :'"
                      class="mb-0"
                    >
                      <input
                        type="color"
                        v-model="configPrint.schoolYear.color"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-collapse-panel>

              <!-- Print Date Panel -->
              <a-collapse-panel
                key="6"
                :header="$t('certification.printDateHeader')"
              >
                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item
                      :label="$t('certification.enable')"
                      class="mb-2"
                    >
                      <a-switch v-model="configPrint.printDate.enabled" />
                    </a-form-item>
                  </a-col>
                  <template v-if="configPrint.printDate.enabled">
                    <a-col :span="24">
                      <a-form-item
                        :label="$t('certification.certificateDate')"
                        class="mb-0"
                      >
                        <a-date-picker
                          :allowClear="false"
                          :value="printDateValue"
                          format="DD/MM/YYYY"
                          style="width: 100%"
                          @change="onPrintDateChange"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.placeholderX')"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderX')"
                          class="w-100"
                          v-model="configPrint.printDate.x"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.placeholderY')"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderY')"
                          class="w-100"
                          v-model="configPrint.printDate.y"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.size') + ' :'"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderTextSize')"
                          class="w-100"
                          v-model="configPrint.printDate.fontSize"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.color') + ' :'"
                        class="mb-0"
                      >
                        <input
                          type="color"
                          v-model="configPrint.printDate.color"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item
                        :label="$t('certification.format') + ' :'"
                        class="mb-0"
                      >
                        <a-select
                          v-model="configPrint.printDate.format"
                          style="width: 100%"
                        >
                          <a-select-option value="DD/MM/YYYY">{{
                            $t("certification.dateFormatDDMMYYYY")
                          }}</a-select-option>
                          <a-select-option value="YYYY-MM-DD">{{
                            $t("certification.dateFormatYYYYMMDD")
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item
                        :label="$t('certification.textBefore') + ' :'"
                        class="mb-0"
                      >
                        <a-input
                          :placeholder="
                            $t('certification.placeholderDateLabel')
                          "
                          v-model="configPrint.printDate.label"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                </a-row>
              </a-collapse-panel>

              <!-- Stamp Panel -->
              <a-collapse-panel
                key="7"
                :header="$t('certification.stampHeader')"
              >
                <a-row :gutter="16">
                  <a-col :span="24">
                    <a-form-item
                      :label="$t('certification.stampEnabled')"
                      class="mb-2"
                    >
                      <a-switch v-model="configPrint.stamp.enabled" />
                    </a-form-item>
                  </a-col>
                  <template v-if="configPrint.stamp.enabled">
                    <a-col :span="24">
                      <a-alert
                        v-if="!schoolDetails.stamp"
                        :message="$t('certification.stampWarning')"
                        type="warning"
                        show-icon
                        class="mb-2"
                      />
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.placeholderX')"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderX')"
                          class="w-100"
                          v-model="configPrint.stamp.x"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item
                        :label="$t('certification.placeholderY')"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderY')"
                          class="w-100"
                          v-model="configPrint.stamp.y"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item
                        :label="$t('certification.scale') + ' :'"
                        class="mb-0"
                      >
                        <a-input-number
                          :placeholder="$t('certification.placeholderScale')"
                          :min="0.1"
                          :max="3"
                          :step="0.1"
                          class="w-100"
                          v-model="configPrint.stamp.scale"
                        />
                        <span class="subLabel">{{
                          $t("certification.scaleHelp")
                        }}</span>
                      </a-form-item>
                    </a-col>
                  </template>
                </a-row>
              </a-collapse-panel>
            </a-collapse>

            <!-- Action Buttons -->
            <a-row :gutter="16" class="mt-3">
              <a-col :span="12">
                <a-button
                  type="primary"
                  class="w-100 mb-0"
                  @click="showPreview"
                >
                  <a-icon type="eye" />{{ $t("action.preview") }}
                </a-button>
              </a-col>
              <a-col :span="12">
                <a-button
                  type="primary"
                  class="w-100"
                  :disabled="saveLoading || isReadOnly"
                  :loading="saveLoading"
                  @click="handelEdit"
                >
                  <a-icon type="save" />{{ $t("all.save") }}
                </a-button>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapGetters } from "vuex";
import { drawCertifcate } from "@/utilities/pdfCertificate";
import moment from "moment";

export default {
  name: "certifications",
  props: ["certif", "visible", "selectedCertType"],
  beforeMount() {
    this.formEdit = this.$form.createForm(this, {
      name: "editCertificationForm",
    });
  },
  mounted() {
    if (this.certif.configPrint) {
      this.configPrint = this.certif.configPrint;
      if (!this.configPrint.trimestre)
        this.configPrint.trimestre = this.defaultConfigPrint.trimestre;
      if (!this.configPrint.schoolYear)
        this.configPrint.schoolYear = this.defaultConfigPrint.schoolYear;
      if (!this.configPrint.printDate)
        this.configPrint.printDate = { ...this.defaultConfigPrint.printDate };
      else
        this.configPrint.printDate = {
          ...this.defaultConfigPrint.printDate,
          ...this.configPrint.printDate,
        };
      this.ensurePrintDateValue();
      if (!this.configPrint.stamp)
        this.configPrint.stamp = this.defaultConfigPrint.stamp;
      this.showPreview();
    } else {
      this.configPrint = JSON.parse(JSON.stringify(this.defaultConfigPrint));
      this.ensurePrintDateValue();
      this.showPreview();
    }
  },
  watch: {
    "configPrint.printDate.enabled"(enabled) {
      if (enabled) this.ensurePrintDateValue();
    },
  },
  data() {
    return {
      loadingPdfPreview: true,
      form: this.$form.createForm(this),
      data: null,
      cacheData: null,
      currentCertif: undefined,
      pdfBlobUrl: "",
      fontGroups: [
        {
          label: this.$t("bulletin.arabicAndFrench"),
          options: [
            { value: "Amiri", label: this.$t("bulletin.amiriNormal") },
            { value: "Amiri-Bold", label: this.$t("bulletin.amiriBold") },
            {
              value: "NotoNaskhArabic",
              label: this.$t("bulletin.notoNaskhArabicNormal"),
            },
          ],
        },
        {
          label: this.$t("bulletin.arabicOnly"),
          options: [
            {
              value: "Noto Sans Arabic-Bold",
              label: this.$t("bulletin.notoSansArabicBold"),
            },
            {
              value: "Al Jazeera Arabic-Bold",
              label: this.$t("bulletin.alJazeeraArabicBold"),
            },
          ],
        },
        {
          label: this.$t("etablissement.other"),
          options: [
            {
              value: "AlHurra Font Regular",
              label: "AlHurra",
            },
            {
              value: "ArbFONTS_Alexandria_VariableFont_wght",
              label: "Alexandria",
            },
            {
              value: "ArbFONTS_Sukar_Bold_1",
              label: "Sukar",
            },
            {
              value: "ArbFONTS_sultani_bold",
              label: "Sultani",
            },
            {
              value: "DroidSansArabic",
              label: "Droid Sans Arabic",
            },
            {
              value: "NotoKufiArabic_Bold",
              label: "Noto Kufi Arabic Bold",
            },
            {
              value: "NotoKufiArabic_Regular",
              label: "Noto Kufi Arabic Regular",
            },
            {
              value: "STC_Bold",
              label: "STC",
            },
            {
              value: "Tajawal_Bold",
              label: "Tajawal",
            },
          ],
        },
      ],
      configPrint: {
        orientation: "l", // portrait or portrait (l or p)
        font: "Amiri",
        xAlign: "left",
        fullName: {
          x: 70,
          y: 105,
          fontSize: 30,
          color: "#000000",
        },
        className: {
          x: 180,
          y: 127,
          fontSize: 19,
          color: "#000000",
        },
        trimestre: {
          x: 200,
          y: 200,
          fontSize: 19,
          color: "#000000",
        },
        schoolYear: {
          x: 190,
          y: 250,
          fontSize: 19,
          color: "#000000",
        },
        printDate: {
          enabled: true,
          x: 180,
          y: 270,
          fontSize: 14,
          color: "#000000",
          format: "DD/MM/YYYY",
          label: "",
          value: null,
        },
        stamp: {
          enabled: false,
          x: 20,
          y: 240,
          scale: 1,
        },
      },
      saveLoading: false,
      defaultConfigPrint: {
        orientation: "l", // portrait or portrait (l or p)
        font: "Amiri",
        xAlign: "left",
        fullName: {
          x: 70,
          y: 105,
          fontSize: 30,
          color: "#000000",
        },
        className: {
          x: 180,
          y: 127,
          fontSize: 19,
          color: "#000000",
        },
        trimestre: {
          x: 200,
          y: 200,
          fontSize: 19,
          color: "#000000",
        },
        schoolYear: {
          x: 190,
          y: 250,
          fontSize: 19,
          color: "#000000",
        },
        printDate: {
          enabled: true,
          x: 180,
          y: 270,
          fontSize: 14,
          color: "#000000",
          format: "DD/MM/YYYY",
          label: "",
          value: null,
        },
        stamp: {
          enabled: false,
          x: 20,
          y: 240,
          scale: 1,
        },
      },
    };
  },
  computed: {
    printDateValue() {
      const value = this.configPrint?.printDate?.value;
      return value ? moment(value, "YYYY-MM-DD") : moment();
    },
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.certificats;
      return value === "ro";
    },
    schoolDetails() {
      return (
        this.user.building.filter(
          (el) => el.dbName == this.settings.activeBuilding
        )[0] || {}
      );
    },
  },
  methods: {
    ensurePrintDateValue() {
      if (
        this.configPrint.printDate.enabled &&
        !this.configPrint.printDate.value
      ) {
        this.configPrint.printDate.value = moment().format("YYYY-MM-DD");
      }
    },
    onPrintDateChange(val) {
      if (!val) return;
      this.configPrint.printDate.value = val.format("YYYY-MM-DD");
      this.showPreview();
    },
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    handleCancel() {
      this.$emit("close");
    },
    async showPreview() {
      try {
        console.log(this.configPrint);
        this.loadingPdfPreview = true;
        let sampleDate = {
          fullName: "الإسم و اللقب",
          classroomName: "اسم القسم",
          trimestre: "3",
        };
        let { start, end } = this.settings.schoolarYears.find(
          (el) => el._id == this.settings.activeSchoolarYear
        );

        start = new Date(start).getFullYear();
        end = new Date(end).getFullYear();

        let schoolarYearName = end + " / " + start;
        let certifImgUrl = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          this.certif.fileM
        );
        // Add stamp URL if available
        if (this.schoolDetails.stamp) {
          sampleDate.stampUrl = this.settings.resourcesUrl.replace(
            "FILE_PATH",
            this.schoolDetails.stamp
          );
        }

        const doc = await drawCertifcate(
          sampleDate,
          this.configPrint,
          certifImgUrl,
          schoolarYearName,
          true
        );
        this.pdfBlobUrl = doc.output("bloburl");
        this.loadingPdfPreview = false;
      } catch (error) {
        console.error(error);
      }
    },
    handelEdit(e) {
      e.preventDefault();
      this.formEdit.validateFieldsAndScroll((err, values) => {
        if (err) return;
        this.saveLoading = true;
        const id = this.certif.id;
        // data: values,
        const formData = new FormData();
        formData.append("configPrint", this.configPrint);
        let data = {
          configPrint: this.configPrint,
        };
        apiClient
          .patch("/certification/" + id + "/" + this.selectedCertType, data)
          .then(async (res) => {
            this.$emit("save");
            this.$message.success(this.$t("success.certificationMSA"));
            this.handleCancel();
          })
          .catch((e) => {
            this.handleApiError(e, this.$t("error.modif"));
          })
          .finally(() => (this.saveLoading = false));
      });
    },
  },
};
</script>
